(function(){
  const money = (cents, currency) => {
    const value = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency || 'GBP',maximumFractionDigits:value % 1 ? 2 : 0}).format(value); }
    catch(e){ return '£' + value.toFixed(value % 1 ? 2 : 0); }
  };

  document.querySelectorAll('[data-ticket-product]').forEach(root => {
    const dataEl = root.querySelector('[data-variants-json]');
    let variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch(e) {}
    const currency = 'GBP';
    const idInput = root.querySelector('[name="id"]');
    const priceEls = root.querySelectorAll('[data-selected-price]');
    const compareEls = root.querySelectorAll('[data-selected-compare]');
    const titleEls = root.querySelectorAll('[data-selected-title]');
    const buttons = root.querySelectorAll('[data-variant-button]');
    const select = root.querySelector('[data-variant-select]');
    const qtyInput = root.querySelector('[data-quantity]');

    function setVariant(id){
      const variant = variants.find(v => String(v.id) === String(id)) || variants[0];
      if(!variant) return;
      if(idInput) idInput.value = variant.id;
      if(select) select.value = variant.id;
      buttons.forEach(btn => btn.classList.toggle('is-active', String(btn.dataset.variantButton) === String(variant.id)));
      priceEls.forEach(el => el.textContent = money(variant.price, currency));
      compareEls.forEach(el => { el.textContent = ''; el.hidden = true; });
      titleEls.forEach(el => el.textContent = variant.title);
    }
    buttons.forEach(btn => btn.addEventListener('click', () => setVariant(btn.dataset.variantButton)));

    // Static ticket-group selector fallback used when no Shopify product is assigned.
    root.querySelectorAll('.variant-option[data-price]:not([data-variant-button])').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('.variant-option[data-price]:not([data-variant-button])').forEach(option => option.classList.toggle('is-active', option === btn));
        priceEls.forEach(el => el.textContent = btn.dataset.price || '');
        compareEls.forEach(el => { el.hidden = true; el.textContent = ''; });
        titleEls.forEach(el => el.textContent = btn.dataset.title || btn.textContent.trim());
      });
    });

    if(select) select.addEventListener('change', () => setVariant(select.value));
    root.querySelectorAll('[data-qty-minus]').forEach(btn => btn.addEventListener('click', () => { if(qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1); }));
    root.querySelectorAll('[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => { if(qtyInput) qtyInput.value = Math.min(4, Number(qtyInput.value || 1) + 1); }));
    if (qtyInput) qtyInput.addEventListener('change', () => { qtyInput.value = Math.min(4, Math.max(1, Number(qtyInput.value || 1))); });
    if(variants[0]) setVariant(variants[0].id);
  });

  document.querySelectorAll('[data-faq]').forEach(faq => {
    faq.querySelectorAll('[data-faq-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-faq-item]');
        if(!item) return;
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    });
  });

  document.querySelectorAll('[data-map]').forEach(map => {
    const img = map.querySelector('img');
    if(!img) return;
    let scale = 1, x = 0, y = 0, dragging = false, sx = 0, sy = 0;
    const apply = () => img.style.transform = `translate(${x}px,${y}px) scale(${scale})`;
    const clamp = () => { scale = Math.min(3.2, Math.max(1, scale)); x = Math.min(180, Math.max(-map.clientWidth * (scale - 1) - 180, x)); y = Math.min(140, Math.max(-map.clientHeight * (scale - 1) - 140, y)); };
    map.closest('.map-panel')?.querySelectorAll('[data-zoom]').forEach(btn => btn.addEventListener('click', () => { scale += btn.dataset.zoom === 'in' ? .25 : -.25; clamp(); apply(); }));
    map.addEventListener('pointerdown', e => { dragging = true; sx = e.clientX - x; sy = e.clientY - y; map.setPointerCapture(e.pointerId); });
    map.addEventListener('pointermove', e => { if(!dragging) return; x = e.clientX - sx; y = e.clientY - sy; clamp(); apply(); });
    map.addEventListener('pointerup', () => dragging = false);
    map.addEventListener('wheel', e => { e.preventDefault(); scale += e.deltaY < 0 ? .15 : -.15; clamp(); apply(); }, {passive:false});
  });
})();

/* Grouped ticket category price sync */
(() => {
  function updateTicketSelection(root, button) {
    root.querySelectorAll('.variant-option').forEach((btn) => btn.classList.remove('is-active'));
    button.classList.add('is-active');

    const variantId = button.getAttribute('data-variant-button');
    const select = root.querySelector('[data-variant-select]');
    const formInput = root.querySelector('.ticket-form input[name="id"]');
    if (variantId) {
      if (select) select.value = variantId;
      if (formInput) formInput.value = variantId;
    }

    const title = button.dataset.title || button.textContent.trim();
    const price = button.dataset.price;

    if (price) root.querySelectorAll('[data-selected-price]').forEach((el) => { el.textContent = price; });
    root.querySelectorAll('[data-selected-title]').forEach((el) => { el.textContent = title; });
  }

  document.querySelectorAll('[data-ticket-product]').forEach((root) => {
    root.querySelectorAll('.variant-option').forEach((button) => {
      if (button.dataset.groupPriceBound === 'true') return;
      button.dataset.groupPriceBound = 'true';
      button.addEventListener('click', () => updateTicketSelection(root, button));
    });
    const active = root.querySelector('.variant-option.is-active') || root.querySelector('.variant-option');
    if (active) updateTicketSelection(root, active);
  });
})();

/* Category deep links: /collections/all?section=cat1|floor|cat2 */
(() => {
  const params = new URLSearchParams(window.location.search);
  const requested = (params.get('section') || params.get('ticket') || '').toLowerCase().trim();
  if (!requested) return;

  const aliases = {
    cat1: ['cat1', 'cat 1', 'reserved'],
    floor: ['floor', 'standing', 'ga', 'fosse'],
    cat2: ['cat2', 'cat 2', 'upper'],
    reserved: ['cat1', 'cat 1', 'reserved'],
    fosse: ['floor', 'standing', 'ga', 'fosse'],
    gold: ['cat2', 'cat 2', 'upper']
  };
  const wanted = aliases[requested] || [requested];

  function findTarget(root) {
    const buttons = Array.from(root.querySelectorAll('.variant-option'));
    return buttons.find((button) => (button.dataset.sectionKey || '').toLowerCase() === requested) ||
      buttons.find((button) => {
        const text = `${button.dataset.title || ''} ${button.textContent || ''}`.toLowerCase();
        return wanted.some((word) => text.includes(word));
      });
  }

  function applyDeepLink() {
    document.querySelectorAll('[data-ticket-product]').forEach((root) => {
      const target = findTarget(root);
      if (!target) return;
      target.click();
      if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(applyDeepLink, 0));
  } else {
    setTimeout(applyDeepLink, 0);
  }
})();




/* Cart page quantity controls, mobile add button, and demo fallback cart */
(() => {
  const parseMoney = (value) => Number(String(value || '').replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
  const formatGBP = (value) => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP', minimumFractionDigits: value % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(value);
  const CART_KEY = 'or_ticket_demo_cart';
  const MAX_TICKETS_PER_SECTION_DAY = 4;

  function selectedTicketKeyFromRoot(root){
    const section = root?.querySelector('[data-section-select]')?.value || root?.querySelector('[data-selected-section-property]')?.value || '';
    const date = root?.querySelector('[data-date-select]')?.value || '';
    return { section, date };
  }

  function showTicketLimitMessage(root, message){
    if (!root) return;
    let messageEl = root.querySelector('[data-ticket-limit-message]');
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.className = 'ticket-limit-message';
      messageEl.setAttribute('data-ticket-limit-message', '');
      const trustLine = root.querySelector('.trust-line');
      if (trustLine) trustLine.insertAdjacentElement('beforebegin', messageEl);
      else root.querySelector('.purchase-panel')?.appendChild(messageEl);
    }
    messageEl.textContent = message;
    messageEl.hidden = false;
    clearTimeout(messageEl._hideTimer);
    messageEl._hideTimer = setTimeout(() => { messageEl.hidden = true; }, 4500);
  }

  async function getShopifyCart(){
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return null;
      return await response.json();
    } catch(e) {
      return null;
    }
  }

  function countMatchingShopifyTickets(cart, date, section){
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((sum, item) => {
      const props = item.properties || {};
      const itemDate = props.Date || props.date || '';
      const itemSection = props.Section || props.section || '';
      return itemDate === date && itemSection === section ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function capTicketQuantity(root, requestedQty, existingQty){
    const remaining = Math.max(0, MAX_TICKETS_PER_SECTION_DAY - Number(existingQty || 0));
    const allowed = Math.min(Math.max(1, Number(requestedQty || 1)), remaining);
    const qtyInput = root?.querySelector('[data-quantity]');
    if (qtyInput) qtyInput.value = Math.max(1, Math.min(MAX_TICKETS_PER_SECTION_DAY, allowed || 1));
    return { remaining, allowed };
  }

  async function refreshShopifyCartBadge(){
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.dataset.serverCount = String(cart.item_count || 0);
        badge.textContent = String(cart.item_count || 0);
        badge.hidden = Number(cart.item_count || 0) <= 0;
        badge.setAttribute('aria-label', (cart.item_count || 0) + ((cart.item_count || 0) === 1 ? ' article dans le panier' : ' articles dans le panier'));
      });
    } catch(e) {}
  }

  function showAddedState(button){
    if (!button) return;
    const original = button.dataset.originalText || button.textContent;
    button.dataset.originalText = original;
    button.textContent = 'ajouté au panier';
    button.classList.add('is-added');
    setTimeout(() => {
      button.textContent = button.dataset.originalText || original;
      button.classList.remove('is-added');
    }, 1500);
  }

  document.querySelectorAll('.ticket-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitter = event.submitter || form.querySelector('button[type="submit"]');
      const root = form.closest('[data-ticket-product]');
      const qtyInput = root?.querySelector('[data-quantity]');
      const requestedQty = Math.min(MAX_TICKETS_PER_SECTION_DAY, Math.max(1, Number(qtyInput?.value || 1)));
      if (qtyInput) qtyInput.value = requestedQty;

      const { date, section } = selectedTicketKeyFromRoot(root);
      const cart = await getShopifyCart();
      const existingQty = countMatchingShopifyTickets(cart, date, section);
      const { remaining, allowed } = capTicketQuantity(root, requestedQty, existingQty);

      if (remaining <= 0) {
        showTicketLimitMessage(root, 'Tu as déjà 4 billets pour cette date et cette section dans ton panier.');
        return;
      }
      if (allowed < requestedQty) {
        showTicketLimitMessage(root, `Tu peux encore ajouter ${remaining} billet${remaining === 1 ? '' : 's'} pour cette date et cette section.`);
      }

      try {
        const formData = new FormData(form);
        formData.set('quantity', String(allowed));
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!response.ok) throw new Error('Erreur ajout panier');
        await refreshShopifyCartBadge();
        showAddedState(submitter);
      } catch(e) {
        form.submit();
      }
    });
  });

  function getClientCart(){
    try { return JSON.parse(localStorage.getItem(CART_KEY) || '[]').filter((item) => Number(item.quantity || 0) > 0); }
    catch(e) { return []; }
  }

  function updateCartBadge(){
    const clientQty = getClientCart().reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      const serverQty = Number(badge.dataset.serverCount || badge.textContent || 0);
      const qty = serverQty > 0 ? serverQty : clientQty;
      badge.textContent = String(qty);
      badge.hidden = qty <= 0;
      badge.setAttribute('aria-label', qty + (qty === 1 ? ' article dans le panier' : ' articles dans le panier'));
    });
  }

  document.querySelectorAll('[data-mobile-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-ticket-product]');
      const productSubmit = root?.querySelector('.ticket-form button[type="submit"]');
      if (productSubmit) {
        productSubmit.click();
        return;
      }
      const fallback = root?.querySelector('[data-fallback-add]');
      if (fallback) fallback.click();
    });
  });

  document.querySelectorAll('[data-fallback-add]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-ticket-product]');
      if (!root) return;
      const active = root.querySelector('.variant-option.is-active') || root.querySelector('.variant-option');
      const qtyInput = root.querySelector('[data-quantity]');
      const quantity = Math.max(1, Math.min(4, Number(qtyInput?.value || 1)));
      const exactSection = root.querySelector('[data-section-select]')?.value || root.querySelector('[data-selected-section-property]')?.value || '';
      const date = root.querySelector('[data-date-select]')?.value || '23 avril 2027';
      const section = exactSection || active?.dataset.title || active?.textContent.trim() || 'CAT2';
      const priceText = active?.dataset.price || root.querySelector('[data-selected-price]')?.textContent || '£0';
      const price = parseMoney(priceText);
      const key = `${date} ${section}`.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const cart = getClientCart();
      const existing = cart.find((item) => item.key === key);
      const existingQty = existing ? Number(existing.quantity || 0) : 0;
      const remaining = Math.max(0, MAX_TICKETS_PER_SECTION_DAY - existingQty);
      const allowed = Math.min(quantity, remaining);
      if (remaining <= 0) {
        showTicketLimitMessage(root, 'Tu as déjà 4 billets pour cette date et cette section dans ton panier.');
        return;
      }
      if (allowed < quantity) showTicketLimitMessage(root, `Tu peux encore ajouter ${remaining} billet${remaining === 1 ? '' : 's'} pour cette date et cette section.`);
      if (existing) existing.quantity = Math.min(MAX_TICKETS_PER_SECTION_DAY, existingQty + allowed);
      else cart.push({ key, section, date, price, priceText, quantity: allowed });
      localStorage.setItem(CART_KEY, JSON.stringify(cart));
      updateCartBadge();
      showAddedState(button);
    });
  });

  document.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.cart-qty')?.querySelector('input');
      if (!input) return;
      const delta = button.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      input.value = Math.min(4, Math.max(0, Number(input.value || 0) + delta));
    });
  });

  function renderClientCart() {
    const panel = document.querySelector('[data-client-cart]');
    if (!panel) return;
    const serverHasItems = document.querySelector('.cart-form');
    if (serverHasItems) return;
    const cart = getClientCart();
    const empty = document.querySelector('[data-empty-cart]');
    const lines = panel.querySelector('[data-client-cart-lines]');
    if (!cart.length) {
      panel.hidden = true;
      if (lines) lines.innerHTML = '';
      if (empty) empty.hidden = false;
      updateCartBadge();
      return;
    }

    if (empty) empty.hidden = true;
    panel.hidden = false;

    const countEl = panel.querySelector('[data-client-cart-count]');
    const totalEl = panel.querySelector('[data-client-cart-total]');
    const totalQty = cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const total = cart.reduce((sum, item) => sum + (Number(item.price || 0) * Number(item.quantity || 0)), 0);
    countEl.textContent = String(totalQty);
    totalEl.textContent = formatGBP(total);
    lines.innerHTML = cart.map((item) => `
      <article class="cart-line" data-client-key="${item.key}">
        <div class="cart-line-main">
          <div class="cart-ticket-icon">🎟</div>
          <div><h2>Billets Olivia Rodrigo</h2><p class="cart-section">${item.date ? item.date + ' • ' : ''}${item.section}</p></div>
        </div>
        <div class="cart-line-price"><strong>${formatGBP(item.price * item.quantity)}</strong><span>${formatGBP(item.price)} chacun</span></div>
        <div class="cart-line-qty">
          <label>Quantité</label>
          <div class="qty cart-qty"><button type="button" data-client-minus>−</button><input value="${item.quantity}" min="0" max="4" inputmode="numeric" aria-label="Quantité pour ${item.section}"><button type="button" data-client-plus>+</button></div>
          <button class="cart-remove client-remove" type="button">supprimer</button>
        </div>
      </article>`).join('');

    lines.querySelectorAll('[data-client-minus], [data-client-plus], .client-remove').forEach((control) => {
      control.addEventListener('click', () => {
        const line = control.closest('[data-client-key]');
        const key = line?.dataset.clientKey;
        const updated = getClientCart();
        const item = updated.find((entry) => entry.key === key);
        if (!item) return;
        if (control.classList.contains('client-remove')) item.quantity = 0;
        else item.quantity = Math.min(4, Math.max(0, Number(item.quantity || 0) + (control.hasAttribute('data-client-plus') ? 1 : -1)));
        localStorage.setItem(CART_KEY, JSON.stringify(updated.filter((entry) => Number(entry.quantity || 0) > 0)));
        renderClientCart();
      });
    });

    lines.querySelectorAll('[data-client-key] input').forEach((input) => {
      input.addEventListener('change', () => {
        const line = input.closest('[data-client-key]');
        const key = line?.dataset.clientKey;
        const updated = getClientCart();
        const item = updated.find((entry) => entry.key === key);
        if (!item) return;
        item.quantity = Math.min(4, Math.max(0, Number(input.value || 0)));
        localStorage.setItem(CART_KEY, JSON.stringify(updated.filter((entry) => Number(entry.quantity || 0) > 0)));
        renderClientCart();
      });
    });
  }

  renderClientCart();
  updateCartBadge();
})();


(function(){
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-header-menu]');
  const closeButton = document.querySelector('[data-menu-close]');
  if(!toggle || !menu) return;

  function closeMenu(){
    menu.classList.remove('is-open');
    document.body.classList.remove('drawer-menu-open');
    toggle.setAttribute('aria-expanded','false');
  }

  function openMenu(){
    menu.classList.add('is-open');
    document.body.classList.add('drawer-menu-open');
    toggle.setAttribute('aria-expanded','true');
  }

  toggle.addEventListener('click', function(event){
    event.preventDefault();
    event.stopPropagation();
    menu.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  if(closeButton){
    closeButton.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      closeMenu();
    });
  }

  menu.addEventListener('click', function(event){
    event.stopPropagation();
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeMenu();
  });
})();



/* Real Shopify variant binding for date + category + section */
(() => {
  const CATEGORY_DATA = {
    cat2: { label: 'CAT2', price: '£111.20', sections: Array.from({ length: 21 }, (_, i) => {
      const section = 401 + i;
      return { text: `Section ${section}`, value: `Section ${section} - CAT2`, raw: `Section ${section}` };
    })},
    cat1: { label: 'CAT1', price: '£115.60', sections: Array.from({ length: 18 }, (_, i) => {
      const section = 101 + i;
      return { text: `Section ${section}`, value: `Section ${section} - CAT1`, raw: `Section ${section}` };
    })},
    floor: { label: 'Fosse debout', price: '£128.80', sections: [{ text: 'GA', value: 'GA - Fosse debout', raw: 'GA' }] }
  };

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const categoryAliases = {
    cat2: ['cat2', 'cat 2'],
    cat1: ['cat1', 'cat 1'],
    floor: ['fosse debout', 'fosse', 'floor', 'standing', 'ga']
  };

  const dateAliases = {
    '23 avril 2027': ['23 avril 2027', 'april 23, 2027', '2027-04-23', '23/04/2027'],
    '24 avril 2027': ['24 avril 2027', 'april 24, 2027', '2027-04-24', '24/04/2027']
  };

  function variantOptionsText(variant) {
    const parts = [];
    if (variant.title) parts.push(variant.title);
    if (Array.isArray(variant.options)) parts.push(...variant.options);
    ['option1','option2','option3'].forEach((key) => { if (variant[key]) parts.push(variant[key]); });
    return normalize(parts.join(' | '));
  }

  function variantMatchesDate(variant, date) {
    const text = variantOptionsText(variant);
    const aliases = dateAliases[date] || [date];
    return aliases.some((alias) => text.includes(normalize(alias)));
  }

  function variantMatchesCategory(variant, key) {
    const text = variantOptionsText(variant);
    return (categoryAliases[key] || [key]).some((alias) => text.includes(normalize(alias)));
  }

  function variantMatchesSection(variant, sectionRaw, key) {
    const text = variantOptionsText(variant);
    const section = normalize(sectionRaw);
    if (key === 'floor') return text.includes('ga') || text.includes('fosse');
    return text.includes(section);
  }

  function findVariant(variants, date, key, sectionRaw) {
    return variants.find((variant) =>
      variantMatchesDate(variant, date) &&
      variantMatchesCategory(variant, key) &&
      variantMatchesSection(variant, sectionRaw, key)
    ) || variants.find((variant) =>
      variantMatchesCategory(variant, key) &&
      variantMatchesSection(variant, sectionRaw, key)
    ) || variants.find((variant) => variantMatchesCategory(variant, key)) || variants[0];
  }

  function setSectionOptions(root, key) {
    const select = root.querySelector('[data-section-select]');
    if (!select) return;
    const data = CATEGORY_DATA[key] || CATEGORY_DATA.cat2;
    const old = select.value;

    select.innerHTML = '';
    data.sections.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.value;
      option.dataset.rawSection = item.raw;
      option.textContent = item.text;
      select.appendChild(option);
    });

    const stillExists = Array.from(select.options).some((option) => option.value === old);
    if (stillExists) select.value = old;
  }

  function getActiveKey(root) {
    return root.querySelector('.variant-option.is-active')?.dataset.sectionKey || 'cat2';
  }

  function syncSelection(root) {
    const variants = root.__ticketVariants || [];
    const key = getActiveKey(root);
    const data = CATEGORY_DATA[key] || CATEGORY_DATA.cat2;
    const dateSelect = root.querySelector('[data-date-select]');
    const sectionSelect = root.querySelector('[data-section-select]');
    const idInput = root.querySelector('.ticket-form input[name="id"], input[name="id"]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const hiddenSection = root.querySelector('[data-selected-section-property]');

    if (!sectionSelect || !dateSelect) return;

    const selectedOption = sectionSelect.options[sectionSelect.selectedIndex];
    const sectionRaw = selectedOption?.dataset.rawSection || selectedOption?.textContent || sectionSelect.value;
    const date = dateSelect.value;
    const variant = findVariant(variants, date, key, sectionRaw);

    if (variant && idInput) idInput.value = variant.id;
    if (variant && variantSelect) variantSelect.value = variant.id;

    root.querySelectorAll('[data-selected-price]').forEach((el) => {
      if (variant && typeof variant.price !== 'undefined') {
        const amount = Number(variant.price || 0) / 100;
        el.textContent = `£${amount.toFixed(amount % 1 ? 2 : 2)}`;
      } else {
        el.textContent = data.price;
      }
    });

    if (hiddenSection) hiddenSection.value = sectionSelect.value;
    root.querySelectorAll('[data-selected-title]').forEach((el) => { el.textContent = data.label; });
  }

  function initTicketSelector(root) {
    const dataEl = root.querySelector('[data-variants-json]');
    let variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch(e) {}
    root.__ticketVariants = variants;

    const buttons = Array.from(root.querySelectorAll('.variant-option[data-section-key]'));
    buttons.forEach((button) => {
      button.removeAttribute('data-variant-button');
      button.addEventListener('click', () => {
        buttons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
        const key = button.dataset.sectionKey || 'cat2';
        setSectionOptions(root, key);
        syncSelection(root);
      });
    });

    root.querySelectorAll('[data-date-select], [data-section-select]').forEach((select) => {
      select.addEventListener('change', () => syncSelection(root));
    });

    setSectionOptions(root, getActiveKey(root));
    syncSelection(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-ticket-product]').forEach(initTicketSelector));
  } else {
    document.querySelectorAll('[data-ticket-product]').forEach(initTicketSelector);
  }
})();



/* Live Shopify cart quantity totals */
(() => {
  const formatGBP = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: value % 1 ? 2 : 2,
      maximumFractionDigits: value % 1 ? 2 : 2
    }).format(value);
  };

  function liveCartTotals() {
    const lines = Array.from(document.querySelectorAll('[data-cart-line]'));
    const visibleLines = lines.filter((line) => {
      const input = line.querySelector('input[name="updates[]"]');
      return Number(input?.value || 0) > 0 && line.style.display !== 'none';
    });

    let totalQty = 0;
    let totalPrice = 0;

    lines.forEach((line) => {
      const input = line.querySelector('input[name="updates[]"]');
      const qty = Math.min(4, Math.max(0, Number(input?.value || 0)));
      if (input && Number(input.value) !== qty) input.value = qty;

      const unit = Number(line.dataset.unitPrice || 0);
      const lineTotal = qty * unit;
      const target = line.querySelector('[data-line-total]');
      if (target) target.textContent = formatGBP(lineTotal);

      if (qty > 0 && line.style.display !== 'none') {
        totalQty += qty;
        totalPrice += lineTotal;
      }
    });

    document.querySelectorAll('[data-cart-summary-count], [data-cart-count]').forEach((el) => {
      el.textContent = String(totalQty);
      if ('hidden' in el) el.hidden = totalQty === 0;
    });
    document.querySelectorAll('[data-cart-summary-total]').forEach((el) => {
      el.textContent = formatGBP(totalPrice);
    });

    const cartForm = document.querySelector('.cart-form');
    const empty = document.querySelector('[data-empty-cart]');
    if (cartForm && empty && totalQty === 0) {
      cartForm.style.display = 'none';
      empty.hidden = false;
    }
  }

  function saveLine(line, quantity) {
    const lineIndex = Number(line.dataset.lineIndex || 0);
    if (!lineIndex || !window.fetch) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity })
    })
    .then((res) => res.ok ? res.json() : null)
    .then((cart) => {
      if (!cart) return;
      document.querySelectorAll('[data-cart-summary-count], [data-cart-count]').forEach((el) => {
        el.textContent = String(cart.item_count || 0);
        if ('hidden' in el) el.hidden = Number(cart.item_count || 0) === 0;
      });
      document.querySelectorAll('[data-cart-summary-total]').forEach((el) => {
        el.textContent = formatGBP(cart.total_price || 0);
      });
      if (Number(cart.item_count || 0) === 0) {
        const cartForm = document.querySelector('.cart-form');
        const empty = document.querySelector('[data-empty-cart]');
        if (cartForm) cartForm.style.display = 'none';
        if (empty) empty.hidden = false;
      }
    })
    .catch(() => {});
  }

  document.querySelectorAll('[data-cart-line]').forEach((line) => {
    const input = line.querySelector('input[name="updates[]"]');
    if (!input) return;

    const sync = () => {
      const qty = Math.min(4, Math.max(0, Number(input.value || 0)));
      input.value = qty;
      if (qty === 0) line.style.display = 'none';
      liveCartTotals();
      saveLine(line, qty);
    };

    line.querySelectorAll('[data-cart-qty-minus], [data-cart-qty-plus]').forEach((button) => {
      button.addEventListener('click', () => setTimeout(sync, 0));
    });

    input.addEventListener('change', sync);
  });

  liveCartTotals();
})();
